declare const angular: any;

function getQueryParameter(key) {
  return new URLSearchParams(window.location.search).get(key) || "";
}

function loaded(e){
  console.log(e);
}

angular
  .module("app", [])
  .controller("main", [
    "$scope",
    "$http",
    "$rootScope",
    function (_, $http, $rootScope) {
/*      let ejemplo = {
        datos: [
          {
            nombre: "SERV 8:30H",
            _id: 1,
            _id_referencia_defecto: 1,
            maestro: 1,
            valoracion: 14.8,
            volumetrico: 1,
            servicio: {
              nombre: "GLS 8:30Hrs",
              referencia: "9830",
              transito: 1,
              entrega: "8:30",
              _id: 1,
            },
            ruta: "PROVINCIAL",
          },
          {
            nombre: "SERV 10H",
            _id: 3,
            _id_referencia_defecto: 2,
            maestro: 2,
            valoracion: 9.99,
            volumetrico: 1,
            servicio: {
              nombre: "GLS 10Hrs",
              referencia: "9010",
              transito: 1,
              entrega: "10:00",
              _id: 2,
            },
            ruta: "PROVINCIAL",
          },
          {
            nombre: "SERV 14H",
            _id: 4,
            _id_referencia_defecto: 1,
            maestro: 3,
            valoracion: 8.74,
            volumetrico: 1,
            servicio: {
              nombre: "GLS 14Hrs",
              referencia: "9014",
              transito: 1,
              entrega: "14:00",
              _id: 3,
            },
            ruta: "PROVINCIAL",
          },
          {
            nombre: "SERV 24H",
            _id: 5,
            _id_referencia_defecto: 1,
            maestro: 4,
            tipo: "normal",
            valoracion: 7.94,
            volumetrico: 1,
            servicio: {
              nombre: "GLS 24Hrs",
              referencia: "9024",
              transito: 1,
              entrega: "19:30",
              _id: 4,
              alias: ["17"],
            },
            ruta: "PROVINCIAL",
          },
          {
            nombre: "SERV ECONOMY",
            _id: 6,
            _id_referencia_defecto: 1,
            maestro: 7,
            valoracion: 7.54,
            volumetrico: 1,
            servicio: {
              nombre: "GLS ECONOMY 24/72Hrs",
              referencia: "9ECO",
              transito: 3,
              entrega: "19:30",
              _id: 7,
            },
            ruta: "PROVINCIAL",
          },
        ],
        serverInformation: {
          serverName: "*",
          apiVersion: "3.1.17",
          requestDuration: 177,
          currentTime: 1603961978225,
        },
        requesterInformation: {
          id: "9748874189d77bec66d0b429d3d88f9eef22e105-Mc0Jsaq4jbMpJYAX",
          fingerprint: "9748874189d77bec66d0b429d3d88f9eef22e105",
          remoteIP: "127.0.0.1",
          receivedParams: {
            token: "shoppinglogistic-5c41cd10679c8122511d26ad-501bcd6e",
            accion: "get_price",
            bultos: 1,
            peso: 1,
            pais: "ES",
            action: "do",
            apiVersion: 1,
          },
        },
      };*/

      _.data = {
        filter_color:"#"+getQueryParameter("filter_color"),
        buttons_color:"#"+getQueryParameter("buttons_color"),
        fill:"#"+getQueryParameter("fill"),
      }; //getParams()||{};
      console.log( _.data);
      //_.data.color = "#" + (getQueryParameter("color") || "eee");
      _.form = {
        //_id_client: getQueryParameter("_id_client") || "",
        key : getQueryParameter("key") || "",
        to: {
          country:
            getQueryParameter("to_country") ||
            getQueryParameter("from_country") ||
            "",
          zip:
            getQueryParameter("to_zip") || "",
        },
        from: {
          country: getQueryParameter("from_country") || "",
          zip: getQueryParameter("from_zip") || "",
        },
        parcels: [
          {
            k: "1"
          },
        ],
      };

      // para pruebas localess
      _.services = [];

      _.order = (type) => {
        if (!type) {
          // repidez
          _.services = _.services.sort((a, b) => {
            return a.valoracion - b.valoracion;
          });
        } else {
          //precio
          _.services = _.services.sort((a, b) => {
            let A =
              a.servicio.transito +
              ("00000" + (a.servicio.entrega || "19:00")).substr(-5);
            let B =
              b.servicio.transito +
              ("00000" + (b.servicio.entrega || "19:00")).substr(-5);
            return A === B ? 0 : A > B ? 1 : -1;
          });
        }
      };

      _.order(); // ordenar por defecto

      $http.get("/paises.json", { cache: true }).then(function (response) {
        $rootScope.countries = [];
        for (var key in response.data) {
          $rootScope.countries.push({
            key: key,
            data: response.data[key],
          });
        }
        $rootScope.countries.sort((a, b) => {
          return a.data === b.data ? 0 : a.data > b.data ? 1 : -1;
        });
      });

      _.add = () => {
        _.form.parcels.push({
          x: undefined,
          y: undefined,
          z: undefined,
          k: undefined,
        });
      };

      _.quote = function () {
        //var key = getQueryParameter("key") || "";
        _.result = [];
        if (_.form.key && _.form.from.zip) {
          $http
            .post(
             // "http://demos.local.com/api/quote?token=" + key,
              "/quote",
              JSON.stringify(_.form),
              {
                headers: { "Content-Type": "application/json" },
              }
            )
            .then(function (response) {
              //console.log(response);
              _.services = response.data || [];
            });
        } else {
          console.warn("error");
        }
      };
    },
  ])
  .directive("selector", () => {
    return {
      templateUrl: "selector",
      scope: {
        ctx: "=selector",
        countries: "=countries",
      },
      controller: [
        "$scope",
        "$rootScope",
        ($scope, $rootScope) => {
        },
      ],
    };
  })
  .directive("parcel", () => {
    return {
      templateUrl: "parcel",
      scope: {
        ctx: "=parcel",
      },
      controller: [
        "$scope",
        "$rootScope",
        ($scope, $rootScope) => {

        },
      ],
    };
  });
